import { Text } from "@/components/Typography";
import Ellipses from "./Ellipses";

const TranscribingAnimation = ({ ...props }) => {
  return (
    <Text color="$textSecondary" fontFamily="$serif" {...props}>
      Transcribing
      <Ellipses />
    </Text>
  );
};

export default TranscribingAnimation;
